<script setup lang="ts">
    import { ref, computed, toRef } from 'vue'
    import type { NoteLoggerViewModel } from '@Alternatives/Alternatives/Components/NoteLogger'

    const props = defineProps<{
        viewModel: NoteLoggerViewModel
    }>()

    const emit = defineEmits<{
        (e: 'create-note', note: string | null): void
    }>()

    const vm = toRef(props, 'viewModel')

    const note = ref<string | null>(null)

    const opened = computed(() => vm.value?.opened ?? false)

    // ---------------- actions ----------------

    function create()
    {
        emit('create-note', note.value)
    }

    function close()
    {
        vm.value.close()
    }
</script>


<template>
    <div class="modal-mask" v-if="opened">
        <div class="modal-wrapper">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Log a note</h5>
                        <button @click="close" type="button" class="close">&times;</button>
                    </div>
                    <div class="modal-body">
                        <div class="form-group">
                            <textarea v-model.trim="note" class="form-control" rows="5" placeholder="Enter text here..." />
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button @click="close" type="button" class="btn btn-outline-secondary">Cancel</button>
                        <button @click="create" :disabled="!note" type="button" class="btn btn-primary">Create</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>